/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import type * as APITypes from '../API';

type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateVehicleLocation = /* GraphQL */ `subscription OnCreateVehicleLocation(
  $filter: ModelSubscriptionVehicleLocationFilterInput
) {
  onCreateVehicleLocation(filter: $filter) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVehicleLocationSubscriptionVariables,
  APITypes.OnCreateVehicleLocationSubscription
>;
export const onUpdateVehicleLocation = /* GraphQL */ `subscription OnUpdateVehicleLocation(
  $filter: ModelSubscriptionVehicleLocationFilterInput
) {
  onUpdateVehicleLocation(filter: $filter) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleLocationSubscriptionVariables,
  APITypes.OnUpdateVehicleLocationSubscription
>;
export const onDeleteVehicleLocation = /* GraphQL */ `subscription OnDeleteVehicleLocation(
  $filter: ModelSubscriptionVehicleLocationFilterInput
) {
  onDeleteVehicleLocation(filter: $filter) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVehicleLocationSubscriptionVariables,
  APITypes.OnDeleteVehicleLocationSubscription
>;
export const onCreateReservationStatus = /* GraphQL */ `subscription OnCreateReservationStatus(
  $filter: ModelSubscriptionReservationStatusFilterInput
) {
  onCreateReservationStatus(filter: $filter) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateReservationStatusSubscriptionVariables,
  APITypes.OnCreateReservationStatusSubscription
>;
export const onUpdateReservationStatus = /* GraphQL */ `subscription OnUpdateReservationStatus(
  $filter: ModelSubscriptionReservationStatusFilterInput
) {
  onUpdateReservationStatus(filter: $filter) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateReservationStatusSubscriptionVariables,
  APITypes.OnUpdateReservationStatusSubscription
>;
export const onDeleteReservationStatus = /* GraphQL */ `subscription OnDeleteReservationStatus(
  $filter: ModelSubscriptionReservationStatusFilterInput
) {
  onDeleteReservationStatus(filter: $filter) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteReservationStatusSubscriptionVariables,
  APITypes.OnDeleteReservationStatusSubscription
>;
export const onCreateDriverIndividualNotification = /* GraphQL */ `subscription OnCreateDriverIndividualNotification(
  $filter: ModelSubscriptionDriverIndividualNotificationFilterInput
) {
  onCreateDriverIndividualNotification(filter: $filter) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDriverIndividualNotificationSubscriptionVariables,
  APITypes.OnCreateDriverIndividualNotificationSubscription
>;
export const onUpdateDriverIndividualNotification = /* GraphQL */ `subscription OnUpdateDriverIndividualNotification(
  $filter: ModelSubscriptionDriverIndividualNotificationFilterInput
) {
  onUpdateDriverIndividualNotification(filter: $filter) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDriverIndividualNotificationSubscriptionVariables,
  APITypes.OnUpdateDriverIndividualNotificationSubscription
>;
export const onDeleteDriverIndividualNotification = /* GraphQL */ `subscription OnDeleteDriverIndividualNotification(
  $filter: ModelSubscriptionDriverIndividualNotificationFilterInput
) {
  onDeleteDriverIndividualNotification(filter: $filter) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDriverIndividualNotificationSubscriptionVariables,
  APITypes.OnDeleteDriverIndividualNotificationSubscription
>;
export const onCreateVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `subscription OnCreateVehicleOperationScheduleUpdateManagement(
  $filter: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput
) {
  onCreateVehicleOperationScheduleUpdateManagement(filter: $filter) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateVehicleOperationScheduleUpdateManagementSubscriptionVariables,
    APITypes.OnCreateVehicleOperationScheduleUpdateManagementSubscription
  >;
export const onUpdateVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `subscription OnUpdateVehicleOperationScheduleUpdateManagement(
  $filter: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput
) {
  onUpdateVehicleOperationScheduleUpdateManagement(filter: $filter) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateVehicleOperationScheduleUpdateManagementSubscriptionVariables,
    APITypes.OnUpdateVehicleOperationScheduleUpdateManagementSubscription
  >;
export const onDeleteVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `subscription OnDeleteVehicleOperationScheduleUpdateManagement(
  $filter: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput
) {
  onDeleteVehicleOperationScheduleUpdateManagement(filter: $filter) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteVehicleOperationScheduleUpdateManagementSubscriptionVariables,
    APITypes.OnDeleteVehicleOperationScheduleUpdateManagementSubscription
  >;
export const onCreateMobiPFUserTransactionInformation =
  /* GraphQL */ `subscription OnCreateMobiPFUserTransactionInformation(
  $filter: ModelSubscriptionMobiPFUserTransactionInformationFilterInput
) {
  onCreateMobiPFUserTransactionInformation(filter: $filter) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateMobiPFUserTransactionInformationSubscriptionVariables,
    APITypes.OnCreateMobiPFUserTransactionInformationSubscription
  >;
export const onUpdateMobiPFUserTransactionInformation =
  /* GraphQL */ `subscription OnUpdateMobiPFUserTransactionInformation(
  $filter: ModelSubscriptionMobiPFUserTransactionInformationFilterInput
) {
  onUpdateMobiPFUserTransactionInformation(filter: $filter) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateMobiPFUserTransactionInformationSubscriptionVariables,
    APITypes.OnUpdateMobiPFUserTransactionInformationSubscription
  >;
export const onDeleteMobiPFUserTransactionInformation =
  /* GraphQL */ `subscription OnDeleteMobiPFUserTransactionInformation(
  $filter: ModelSubscriptionMobiPFUserTransactionInformationFilterInput
) {
  onDeleteMobiPFUserTransactionInformation(filter: $filter) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteMobiPFUserTransactionInformationSubscriptionVariables,
    APITypes.OnDeleteMobiPFUserTransactionInformationSubscription
  >;
